module.exports = __webpack_public_path__ + "img/slide-11.0fcb9f33.jpeg";